import { t } from '@lingui/core/macro'
import type { ButtonProps } from 'antd'
import { FaSave } from 'react-icons/fa'
import { twMerge } from 'tailwind-merge'
import { ActionButton } from './ActionButton'

export const SaveActionButton = ({
  variant = 'solid',
  color = 'primary',
  icon,
  children,
  className,
  ...props
}: ButtonProps) => {
  return (
    <ActionButton variant={variant} color={color} icon={icon ?? <FaSave />} className={twMerge(className)} {...props}>
      {children ?? t`Speichern`}
    </ActionButton>
  )
}
